export const PageText = {
  _1: 'First steps with the aircheckr API and widget',
  _2: 'aircheckr is API based, allowing an easy machine-to-machine communication between your customers device and the aircheckr servers. The aircheckr API can be integrated into your service in a snap! You can also boost your website with the aircheckr widget.'
};

export const Categories = {
  _1: {
    title: 'Signup',
    subcategories: [
      {
        key: 0,
        subtitle: 'The aircheckr access token',
        text: 'All you need to start using aircheckr is a personal aircheckr access token. It\'s a short code that lets you use aircheckr within your own service or product. You can use the same token for all our REST APIs and widgets.',
        text_2: 'You can get your aircheckr access token on your personal account page. You first have to <a href="/signup">register</a>. If you are already registered, just <a href="/login">sign in</a> and go to your personal account page. You will find your personal access token there.'
      }
    ]
  },
  _2: {
    title: 'Choose a plan',
    subcategories: [
      {
        key: 0,
        subtitle: 'Something for everyone',
        text: 'If you just registered, you automatically get our free plan. This plan allows you to learn the possibilities of aircheckr without paying anything and without any obligations. Check out the different subscription plans <a href="/pricing">here</a>. You can upgrade your account. Or <a href="/contact">contact us</a> so we can help you match the possibilities of aircheckr with your specific needs.',
        text_2: 'In your personal account page, you can see your current plan/license. <a href="/contact">Contact us</a> if you would like to change it. '
      }
    ]
  },
  _3: {
    title: 'Integrate',
    subcategories: [
      {
        key: 0,
        subtitle: 'Let’s get it working',
        text: 'This personal aircheckr access token needs to be included in the API call or in the widget. Without it the API or the widget will not work.',
        text_2:'For the API, add the complete token in the indicated spot as your request header (x-acces-token=Your_Token), without any spaces. It is explained in more detail in the <a href="/api_docs" target="_blank">API developer documentation</a>',
        text_3: 'To use the widget in your own website, <a href="https://www.aircheckr.com/contact">contact us</a> and we will help you.'

      }
    ]
  },
  _4: {
    title: 'Follow-up',
    subcategories: [
      {
        key: 0,
        subtitle: 'Usage metrics',
        text: 'In your account page, you can easily track the metrics of your api usage.'
      }
    ]
  }
};

export default PageText;



// WEBPACK FOOTER //
// ./src/input-text/en/help-and-guides/first-steps-with-the-aircheckr-api_page.js